import urls from '../api_urls/whiteList'
import { _post } from '@/axios/request'
// 获取列表
export function getTableData (params) {
  return _post(urls.GET_LIST, params)
}
// 获取role
export function getRole (params) {
  return _post(urls.GET_ROLE, params)
}
// 新增白名单
export function save (params) {
  return _post(urls.SAVE, params)
}
// 校验
export function check (params) {
  return _post(urls.CHECK, params)
}
// 编辑
export function update (params) {
  return _post(urls.UPDATE, params)
}
// 获取详情
export function find (params) {
  return _post(urls.FIND, params)
}
// 删除
export function deleteWhiteList (params) {
  return _post(urls.DELETE, params)
}
// 删除
export function deleteCustomerCompany (params) {
  return _post(urls.DELETE_CUSTOMER_COMPANY, params)
}
// 批量更新
export function updateForBatch (params) {
  return _post(urls.UPDATE_FOR_BATCH, params)
}
// 批量解析
export function analysisUsers (params) {
  return _post(urls.ANALYSIS_USERS, params)
}
// 批量删除角色
export function deleteRoles (params) {
  return _post(urls.DELETE_ROLES, params)
}
// 批量修改角色
export function assignRoles (params) {
  return _post(urls.ASSIGN_ROLES, params)
}
// 更新状态
export function updateStatus (params) {
  return _post(urls.UPDATE_STATUS, params)
}
// 更新状态
export function updateCustomerCompanyStatus (params) {
  return _post(urls.UPDATE_CUSTOMER_COMPANY_STATUS, params)
}
// 获取注册账户
export function getRegisteredAccount (params) {
  return _post(urls.GET_REGISTERED_ACCOUNT, params)
}
// 获取白名单公司下拉列表
export function findCompanyFilter (params) {
  return _post(urls.FIND_COMPANY_FILTER, params)
}
// 获取白名单集团下拉列表
export function findGroupFilter (params) {
  return _post(urls.FIND_GROUP_FILTER, params)
}
// domain 提交后弹窗列表
export function getSuffixList (params) {
  return _post(urls.GET_SUFFIX_LIST, params)
}
// 获取Customer Company
export function getCustomerCompanyData (params) {
  return _post(urls.getCustomerCompanyData, params)
}
// 获取Customer Group
export function getCustomerGroupData (params) {
  return _post(urls.getCustomerGroupData, params)
}
// 获取Customer company列表
export function getCustomerCompanyTableData (params) {
  return _post(urls.getCustomerCompanyTableData, params)
}
// 编辑
export function updateCustomerCompany (params) {
  return _post(urls.UPDATE_CUSTOMER_COMPANY, params)
}
// 获取详情
export function findCustomerCompany (params) {
  return _post(urls.FIND_CUSTOMER_COMPANY, params)
}



// WEBPACK FOOTER //
// ./src/axios/api/whiteList.js